import { deepGet } from '../shared/helper'

export default class Language {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  setTranslations() {
    this.germanIso = deepGet(this, 'translations.de.name')
    this.englishIso = deepGet(this, 'translations.en.name')
  }

  getDefault() {
    return {
      id: null,
      translations: {
        de: {
          name: null,
          description: null
        },
        en: {
          name: null,
          description: null
        }
      },
      accountCount: 0,
      iso: null,
      isIso: false,
      name: null,
      defaultIso: null,
    }
  }

  set(data) {
    Object.assign(this, data)
    this.setTranslations()
  }

  getJSON() {
    return {
      id: this.id,
      iso: this.iso,
      translations: this.translations,
      isIso: this.isIso,
      defaultIso: this.defaultIso,
      name: this.name,
      deeplLanguageId: this.deeplLanguageId,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/languages/model.js